/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Deletedescription2Inputs */

const zh_organizationsettings_deletedescription2 = /** @type {(inputs: Organizationsettings_Deletedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此操作不可撤销。组织的所有数据、成员和共享资源将被永久删除。`)
};

const en_organizationsettings_deletedescription2 = /** @type {(inputs: Organizationsettings_Deletedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. All data, members, and shared resources in this organization will be permanently deleted.`)
};

const es_organizationsettings_deletedescription2 = /** @type {(inputs: Organizationsettings_Deletedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción no se puede deshacer. Todos los datos, miembros y recursos compartidos de esta organización se eliminarán permanentemente.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone. All data, members, and shared resources in this organization will be permanently deleted." |
*
* @param {Organizationsettings_Deletedescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_deletedescription2 = /** @type {((inputs?: Organizationsettings_Deletedescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Deletedescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_deletedescription2(inputs)
	if (locale === "en") return en_organizationsettings_deletedescription2(inputs)
	return es_organizationsettings_deletedescription2(inputs)
});
export { organizationsettings_deletedescription2 as "organizationSettings_deleteDescription" }